var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"switch switch-outline switch-icon switch-success"},[_c('label',[_c('input',_vm._b({domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.setChecked}},'input',_vm.$attrs,false)),_c('span')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }